import React, { useEffect, useState } from "react";
import Form, {
  SimpleItem, GroupItem, Label, RequiredRule, ButtonItem, ButtonOptions
} from 'devextreme-react/form';
import { LVForm } from "../Basicos/LVForm";
import ComboAbmZonEmpresas from "../Compuestos/Combos/ComboAbmZonEmpresas";
import {
  function_ABM_ZON_Plantas_Generar_JSON, function_ABM_ZON_Plantas_Insertar, function_ABM_ZON_Plantas_Leer,
  function_ABM_ZON_Plantas_Modificar, function_ABM_ZON_Plantas_ModificarImagenAlternativa1,
  function_ABM_ZON_Plantas_ModificarImagenAlternativa2, function_ABM_ZON_Plantas_ModificarImagenAlternativa3,
  function_ABM_ZON_Plantas_ModificarLogo
} from "neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Plantas";
import { function_base64ToHex } from "../../funciones/Varios";
import LVButtonAccion from "../Basicos/LVButtonAccion";

const ABM_ZON_Plantas = (props) => {
  const [datos, setDatos] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [esModificacion, setEsModificacion] = useState(false);
  const [valorCodigoEmpresa, setValorCodigoEmpresa] = useState(null);
  const [imagenLogoBase64, setImagenLogoBase64] = useState(null);
  const [imagenLogoPreview, setImagenLogoPreview] = useState(null);
  const [imagenAlternativa1Base64, setImagenAlternativa1Base64] = useState(null);
  const [imagenAlternativa1Preview, setImagenAlternativa1Preview] = useState(null);
  const [imagenAlternativa2Base64, setImagenAlternativa2Base64] = useState(null);
  const [imagenAlternativa2Preview, setImagenAlternativa2Preview] = useState(null);
  const [imagenAlternativa3Base64, setImagenAlternativa3Base64] = useState(null);
  const [imagenAlternativa3Preview, setImagenAlternativa3Preview] = useState(null);

  const handleOnClick_Guardar = async (e) => {
    try {

      const JSON = await function_ABM_ZON_Plantas_Generar_JSON(
        datos.CodigoPlanta, valorCodigoEmpresa,
        datos.Descripcion,
        datos.IdPais,
        datos.Calle,
        datos.Numero,
        datos.Piso,
        datos.Depto,
        datos.Email,
        datos.Telefono,
        datos.Logo,
        datos.CodLocalExterno,
        datos.CodRubroExterno,
        datos.CodContratoExterno,
        datos.RappiStoreId,
        datos.RappiToken,
        datos.CierreZetaManual,
        datos.PuntoVentaConBotonTKA,
        datos.PuntoVentaConBotonTKB,
        datos.PuntoVentaConBotonTKM,
        datos.PuntoVentaConBotonTKNCA,
        datos.PuntoVentaConBotonTKNCB,
        datos.PuntoVentaConBotonTKNCM,
        datos.PuntoVentaConBotonFCA,
        datos.PuntoVentaConBotonFCB,
        datos.PuntoVentaConBotonFCC,
        datos.PuntoVentaConBotonFCM,
        datos.PuntoVentaConBotonPedidos,
        datos.PuntoVentaConBotonCotizaciones,
        datos.PuntoVentaConBotonCancelaTicket,
        datos.PuntoVentaConBotonObservaciones,
        datos.CierreZetaCiego,
        datos.PuntoCompraConBotonTKA,
        datos.PuntoCompraConBotonTKB,
        datos.PuntoCompraConBotonTKM,
        datos.PuntoCompraConBotonTKNCA,
        datos.PuntoCompraConBotonTKNCB,
        datos.PuntoCompraConBotonTKNCM,
        datos.PuntoCompraConBotonFCA,
        datos.PuntoCompraConBotonFCB,
        datos.PuntoCompraConBotonFCC,
        datos.PuntoCompraConBotonFCM,
        datos.PuntoCompraConBotonPedidos,
        datos.PuntoCompraConBotonCotizaciones,
        datos.PuntoCompraConBotonObservaciones
      )

      if (props.Codigo.Codigo === "--NUEVO--") {

        const Creado = await function_ABM_ZON_Plantas_Insertar(JSON, false)

        alert("Se ha generado el Código: " + Creado.data.codigoGenerado)
      } else {

        const Modificado = await function_ABM_ZON_Plantas_Modificar(JSON, false)

        alert("Se ha modificado el Código: " + datos.CodigoPlanta)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    }
  }

  const handleOnClick_GuardarImagenLogo = async (e) => {
    try {
      const logoHex = function_base64ToHex(imagenLogoBase64);

      await function_ABM_ZON_Plantas_ModificarLogo(props.Codigo.Codigo, logoHex);
      alert("Logo guardado correctamente");
    } catch (error) {
      alert("Error al guardar el logo");
      console.error(error);
    }
  };

  const handleImagenLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagenLogoPreview(reader.result); // Vista previa
        setImagenLogoBase64(reader.result.split(",")[1]); // Guardar solo la parte Base64
      };
      reader.readAsDataURL(file);
    }
  };

  const handleOnClick_GuardarImagenAlternativa1 = async (e) => {
    try {
      const logoHex = function_base64ToHex(imagenAlternativa1Base64);

      await function_ABM_ZON_Plantas_ModificarImagenAlternativa1(props.Codigo.Codigo, logoHex);
      alert("Imagen Alternativa 1 guardado correctamente");
    } catch (error) {
      alert("Error al guardar el Imagen Alternativa 1");
      console.error(error);
    }
  };

  const handleImagenAlternativa1Change = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagenAlternativa1Preview(reader.result); // Vista previa
        setImagenAlternativa1Base64(reader.result.split(",")[1]); // Guardar solo la parte Base64
      };
      reader.readAsDataURL(file);
    }
  };

  const handleOnClick_GuardarImagenAlternativa2 = async (e) => {
    try {
      const logoHex = function_base64ToHex(imagenAlternativa2Base64);

      await function_ABM_ZON_Plantas_ModificarImagenAlternativa2(props.Codigo.Codigo, logoHex);
      alert("Imagen Alternativa 2 guardado correctamente");
    } catch (error) {
      alert("Error al guardar el Imagen Alternativa 2");
      console.error(error);
    }
  };

  const handleImagenAlternativa2Change = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagenAlternativa2Preview(reader.result); // Vista previa
        setImagenAlternativa2Base64(reader.result.split(",")[1]); // Guardar solo la parte Base64
      };
      reader.readAsDataURL(file);
    }
  };

  const handleOnClick_GuardarImagenAlternativa3 = async (e) => {
    try {
      const logoHex = function_base64ToHex(imagenAlternativa3Base64);

      await function_ABM_ZON_Plantas_ModificarImagenAlternativa3(props.Codigo.Codigo, logoHex);
      alert("Imagen Alternativa 3 guardado correctamente");
    } catch (error) {
      alert("Error al guardar el Imagen Alternativa 3");
      console.error(error);
    }
  };

  const handleImagenAlternativa3Change = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagenAlternativa3Preview(reader.result); // Vista previa
        setImagenAlternativa3Base64(reader.result.split(",")[1]); // Guardar solo la parte Base64
      };
      reader.readAsDataURL(file);
    }
  };

  const onValueChangedCodigoEmpresa = (e) => {
    setValorCodigoEmpresa(e.value)
    datos.CodigoEmpresa = e.value;
  }

  useEffect(() => {

    const getData = async () => {
      try {
        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

          setDatos({
            CodigoPlanta: '',
            Descripcion: '',
            IdPais: 0,
            Calle: '',
            Numero: '',
            Piso: '',
            Depto: '',
            Email: '',
            Telefono: '',
            Logo: '',
            CodLocalExterno: '',
            CodRubroExterno: '',
            CodContratoExterno: '',
            RappiStoreId: '',
            RappiToken: '',
            CierreZetaManual: false,
            PuntoVentaConBotonTKA: false,
            PuntoVentaConBotonTKB: false,
            PuntoVentaConBotonTKM: false,
            PuntoVentaConBotonTKNCA: false,
            PuntoVentaConBotonTKNCB: false,
            PuntoVentaConBotonTKNCM: false,
            PuntoVentaConBotonFCA: false,
            PuntoVentaConBotonFCB: false,
            PuntoVentaConBotonFCC: false,
            PuntoVentaConBotonFCM: false,
            PuntoVentaConBotonPedidos: false,
            PuntoVentaConBotonCotizaciones: false,
            PuntoVentaConBotonCancelaTicket: false,
            PuntoVentaConBotonObservaciones: false,
            CierreZetaCiego: false,
            PuntoCompraConBotonTKA: false,
            PuntoCompraConBotonTKB: false,
            PuntoCompraConBotonTKM: false,
            PuntoCompraConBotonTKNCA: false,
            PuntoCompraConBotonTKNCB: false,
            PuntoCompraConBotonTKNCM: false,
            PuntoCompraConBotonFCA: false,
            PuntoCompraConBotonFCB: false,
            PuntoCompraConBotonFCC: false,
            PuntoCompraConBotonFCM: false,
            PuntoCompraConBotonPedidos: false,
            PuntoCompraConBotonCotizaciones: false,
            PuntoCompraConBotonObservaciones: false
          })
        } else {
          setTituloBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setEsModificacion(true)

          const datosDocumento = await function_ABM_ZON_Plantas_Leer(props.Codigo.Codigo)
          setDatos(datosDocumento.data[0])

          setValorCodigoEmpresa(datosDocumento.data[0].CodigoEmpresa)
          
          if (datosDocumento.data[0]?.Logo) {
            let mimeType = "image/jpeg"; // Valor por defecto

            // Detectar el formato a partir del encabezado de la cadena Base64
            if (datosDocumento.data[0].Logo.startsWith("/9j/")) mimeType = "image/jpeg";
            else if (datosDocumento.data[0].Logo.startsWith("iVBOR")) mimeType = "image/png";
            else if (datosDocumento.data[0].Logo.startsWith("R0lGOD")) mimeType = "image/gif";

            const logoUrl = `data:${mimeType};base64,${datosDocumento.data[0].Logo}`;
            setImagenLogoPreview(logoUrl);
          }

          if (datosDocumento.data[0]?.ImagenAlternativa1) {
            let mimeType = "image/jpeg"; // Valor por defecto

            // Detectar el formato a partir del encabezado de la cadena Base64
            if (datosDocumento.data[0].ImagenAlternativa1.startsWith("/9j/")) mimeType = "image/jpeg";
            else if (datosDocumento.data[0].ImagenAlternativa1.startsWith("iVBOR")) mimeType = "image/png";
            else if (datosDocumento.data[0].ImagenAlternativa1.startsWith("R0lGOD")) mimeType = "image/gif";

            const ImagenAlternativaUrl = `data:${mimeType};base64,${datosDocumento.data[0].ImagenAlternativa1}`;
            setImagenAlternativa1Preview(ImagenAlternativaUrl);
          }

          if (datosDocumento.data[0]?.ImagenAlternativa2) {
            let mimeType = "image/jpeg"; // Valor por defecto

            // Detectar el formato a partir del encabezado de la cadena Base64
            if (datosDocumento.data[0].ImagenAlternativa2.startsWith("/9j/")) mimeType = "image/jpeg";
            else if (datosDocumento.data[0].ImagenAlternativa2.startsWith("iVBOR")) mimeType = "image/png";
            else if (datosDocumento.data[0].ImagenAlternativa2.startsWith("R0lGOD")) mimeType = "image/gif";

            const ImagenAlternativaUrl = `data:${mimeType};base64,${datosDocumento.data[0].ImagenAlternativa2}`;
            setImagenAlternativa2Preview(ImagenAlternativaUrl);
          }

          if (datosDocumento.data[0]?.ImagenAlternativa3) {
            let mimeType = "image/jpeg"; // Valor por defecto

            // Detectar el formato a partir del encabezado de la cadena Base64
            if (datosDocumento.data[0].ImagenAlternativa3.startsWith("/9j/")) mimeType = "image/jpeg";
            else if (datosDocumento.data[0].ImagenAlternativa3.startsWith("iVBOR")) mimeType = "image/png";
            else if (datosDocumento.data[0].ImagenAlternativa3.startsWith("R0lGOD")) mimeType = "image/gif";

            const ImagenAlternativaUrl = `data:${mimeType};base64,${datosDocumento.data[0].ImagenAlternativa3}`;
            setImagenAlternativa3Preview(ImagenAlternativaUrl);
          }
        }
      } catch (error) {
        alert(error);
      }
    }
    getData();
  }, []);

  const validateForm = (e) => {
    e.component.validate();
  };

  return (
    <LVForm
      colCount={3}
      formData={datos}
      onContentReady={validateForm}
    >
      <GroupItem caption="General">
        <SimpleItem dataField="CodigoPlanta" >
          <Label text="Código" />
          <RequiredRule message="Indicar el Código es obligatorio." />
        </SimpleItem>
        <SimpleItem dataField="Descripcion">
          <Label text="Descripción" />
          <RequiredRule message="Indicar la Descripción es obligatorio." />
        </SimpleItem>

        <SimpleItem>
          <Label text="Empresa" />
          <ComboAbmZonEmpresas
            value={valorCodigoEmpresa}
            onValueChanged={onValueChangedCodigoEmpresa} />
        </SimpleItem>

        <SimpleItem>
          <Label text="Cargar Logo" />
          <input type="file" accept="image/*" onChange={handleImagenLogoChange} />
        </SimpleItem>

        {imagenLogoPreview && (
          <SimpleItem>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", marginTop: "10px" }}>
              <img
                src={imagenLogoPreview}
                alt="Vista Previa"
                style={{
                  maxWidth: "100%",
                  maxHeight: "150px",
                  objectFit: "contain",
                }}
              />
              <LVButtonAccion Texto={"GUARDAR LOGO"} onClick={handleOnClick_GuardarImagenLogo} />
            </div>
          </SimpleItem>
        )}

        <SimpleItem>
          <Label text="Cargar Imagen Alternativa 1" />
          <input type="file" accept="image/*" onChange={handleImagenAlternativa1Change} />
        </SimpleItem>

        {imagenAlternativa1Preview && (
          <SimpleItem>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", marginTop: "10px" }}>
              <img
                src={imagenAlternativa1Preview}
                alt="Vista Previa"
                style={{
                  maxWidth: "100%",
                  maxHeight: "150px",
                  objectFit: "contain",
                }}
              />
              <LVButtonAccion Texto={"GUARDAR IMAGEN ALTERNATIVA 1"} onClick={handleOnClick_GuardarImagenAlternativa1} />
            </div>
          </SimpleItem>
        )}

        <SimpleItem>
          <Label text="Cargar Imagen Alternativa 2" />
          <input type="file" accept="image/*" onChange={handleImagenAlternativa2Change} />
        </SimpleItem>

        {imagenAlternativa2Preview && (
          <SimpleItem>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", marginTop: "10px" }}>
              <img
                src={imagenAlternativa2Preview}
                alt="Vista Previa"
                style={{
                  maxWidth: "100%",
                  maxHeight: "150px",
                  objectFit: "contain",
                }}
              />
              <LVButtonAccion Texto={"GUARDAR IMAGEN ALTERNATIVA 2"} onClick={handleOnClick_GuardarImagenAlternativa2} />
            </div>
          </SimpleItem>
        )}

        <SimpleItem>
          <Label text="Cargar Imagen Alternativa 3" />
          <input type="file" accept="image/*" onChange={handleImagenAlternativa3Change} />
        </SimpleItem>

        {imagenAlternativa3Preview && (
          <SimpleItem>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", marginTop: "10px" }}>
              <img
                src={imagenAlternativa3Preview}
                alt="Vista Previa"
                style={{
                  maxWidth: "100%",
                  maxHeight: "150px",
                  objectFit: "contain",
                }}
              />
              <LVButtonAccion Texto={"GUARDAR IMAGEN ALTERNATIVA 3"} onClick={handleOnClick_GuardarImagenAlternativa3} />
            </div>
          </SimpleItem>
        )}
      </GroupItem>

      <GroupItem caption="Dirección">
        <SimpleItem dataField="Calle" >
          <Label text="Calle" />
        </SimpleItem>
        <SimpleItem dataField="Numero">
          <Label text="Número" />
        </SimpleItem>
        <SimpleItem dataField="Piso" >
          <Label text="Piso" />
        </SimpleItem>
        <SimpleItem dataField="Depto">
          <Label text="Depto" />
        </SimpleItem>
      </GroupItem>

      <GroupItem caption="Interfaces">
        <SimpleItem dataField="CodLocalExterno">
          <Label text="CodLocalExterno" />
        </SimpleItem>
        <SimpleItem dataField="CodRubroExterno" >
          <Label text="CodRubroExterno" />
        </SimpleItem>
        <SimpleItem dataField="CodContratoExterno" >
          <Label text="CodContratoExterno" />
        </SimpleItem>
      </GroupItem>

      <GroupItem caption="Contacto" colSpan={2}>
        <SimpleItem dataField="Email">
          <Label text="E-Mail" />
        </SimpleItem>
        <SimpleItem dataField="Telefono" >
          <Label text="Teléfono" />
        </SimpleItem>
      </GroupItem>

      <GroupItem caption="Rappi">
        <SimpleItem dataField="RappiStoreId">
          <Label text="RappiStoreId" />
        </SimpleItem>
        <SimpleItem dataField="RappiToken" >
          <Label text="RappiToken" />
        </SimpleItem>
      </GroupItem>

      <GroupItem caption="Punto de Venta">
        <SimpleItem dataField="PuntoVentaConBotonTKA" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonTKA: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonTKA" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonTKB" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonTKB: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonTKB" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonTKM" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonTKM: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonTKM" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonTKNCA" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonTKNCA: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonTKNCA" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonTKNCB" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonTKNCB: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonTKNCB" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonTKNCM" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonTKNCM: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonTKNCM" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonFCA" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonFCA: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonFCA" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonFCB" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonFCB: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonFCB" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonFCC" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonFCC: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonFCC" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonFCM" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonFCM: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonFCM" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonPedidos" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonPedidos: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonPedidos" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonCotizaciones" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonCotizaciones: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonCotizaciones" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonCancelaTicket" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonCancelaTicket: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonCancelaTicket" />
        </SimpleItem>
        <SimpleItem dataField="PuntoVentaConBotonObservaciones" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoVentaConBotonObservaciones: e.value
              }));
            }
          }}>
          <Label text="PuntoVentaConBotonObservaciones" />
        </SimpleItem>
      </GroupItem>

      <GroupItem caption="Punto de Venta - Cierre de Caja">
        <SimpleItem dataField="CierreZetaManual" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                CierreZetaManual: e.value
              }));
            }
          }}>
          <Label text="CierreZetaManual" />
        </SimpleItem>
        <SimpleItem dataField="CierreZetaCiego" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                CierreZetaCiego: e.value
              }));
            }
          }}>
          <Label text="CierreZetaCiego" />
        </SimpleItem>
      </GroupItem>

      <GroupItem caption="Punto de Compra">
        <SimpleItem dataField="PuntoCompraConBotonTKA" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonTKA: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonTKA" />
        </SimpleItem>
        <SimpleItem dataField="PuntoCompraConBotonTKB" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonTKB: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonTKB" />
        </SimpleItem>
        <SimpleItem dataField="PuntoCompraConBotonTKM" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonTKM: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonTKM" />
        </SimpleItem>
        <SimpleItem dataField="PuntoCompraConBotonTKNCA" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonTKNCA: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonTKNCA" />
        </SimpleItem>
        <SimpleItem dataField="PuntoCompraConBotonTKNCB" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonTKNCB: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonTKNCB" />
        </SimpleItem>
        <SimpleItem dataField="PuntoCompraConBotonTKNCM" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonTKNCM: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonTKNCM" />
        </SimpleItem>
        <SimpleItem dataField="PuntoCompraConBotonFCA" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonFCA: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonFCA" />
        </SimpleItem>
        <SimpleItem dataField="PuntoCompraConBotonFCB" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonFCB: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonFCB" />
        </SimpleItem>
        <SimpleItem dataField="PuntoCompraConBotonFCC" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonFCC: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonFCC" />
        </SimpleItem>
        <SimpleItem dataField="PuntoCompraConBotonFCM" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonFCM: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonFCM" />
        </SimpleItem>
        <SimpleItem dataField="PuntoCompraConBotonPedidos" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonPedidos: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonPedidos" />
        </SimpleItem>
        <SimpleItem dataField="PuntoCompraConBotonCotizaciones" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonCotizaciones: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonCotizaciones" />
        </SimpleItem>
        <SimpleItem dataField="PuntoCompraConBotonObservaciones" editorType="dxCheckBox"
          editorOptions={{
            onValueChanged: (e) => {
              setDatos(prev => ({
                ...prev,
                PuntoCompraConBotonObservaciones: e.value
              }));
            }
          }}>
          <Label text="PuntoCompraConBotonObservaciones" />
        </SimpleItem>
      </GroupItem>

      <ButtonItem horizontalAlignment="Center" colSpan={3}>
        <ButtonOptions onClick={handleOnClick_Guardar} type='success' useSubmitBehavior={true} text={TituloBoton} />
      </ButtonItem>
    </LVForm>
  );

}

export default ABM_ZON_Plantas;